import { isValidObject, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getPriceDetailsStyles = props => {
  var spacingToken = tokens.spacing;
  var _props$priceDetails = props.priceDetails,
    priceDetails = _props$priceDetails === void 0 ? {} : _props$priceDetails,
    _props$infoTagText = props.infoTagText,
    infoTagText = _props$infoTagText === void 0 ? '' : _props$infoTagText;
  return StyleSheet.create({
    prideDetailsContainer: {
      alignItems: 'flex-end'
    },
    priceTexts: {
      marginBottom: spacingToken.SPACING_4
    },
    infoTag: {
      marginBottom: spacingToken.SPACING_4
    },
    tertiaryActionButton: {
      alignSelf: 'center'
    },
    priceDetailsTextContainer: Object.assign({}, !!infoTagText && isValidObject(priceDetails) && (!!(priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.price) || !!(priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.oldPrice)) && {
      marginBottom: tokens.spacing.SPACING_8
    })
  });
};